import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './project.css';
import MOB from '../../assets/portfoliomain/dubbing_animation.webp';
import ENCOUNTERSMAIN from '../../assets/portfoliomain/encounters-port.webp';
import JUJUTSU from '../../assets/portfoliomain/ads_banner.webp';
import CODAMAIN from '../../assets/portfoliomain/coda-port.webp';
import LAFIEVREMAIN from '../../assets/portfoliomain/lafievre-port.webp';
//import FRONTIERE from '../../assets/portfoliomain/frontiere_bg.webp';
import LAMU from '../../assets/portfoliomain/lamu.webp';
import HELLUVA from '../../assets/portfoliomain/helluva-port.webp';
import VENTORY from '../../assets/portfoliomain/Vento800x450.webp';
import THEOUTRUNNER from '../../assets/portfoliomain/theoutrunner_800x450.webp';
import ERREUR from '../../assets/portfoliomain/erreur_main.webp';
import ZAP from '../../assets/portfoliomain/zap_800x450.webp';
import MACHINIST from '../../assets/portfoliomain/anewmachinist.webp';
import FORLORN from '../../assets/portfoliomain/forlorn.webp';
import MEMOIRE from '../../assets/portfoliomain/memoire.webp';
import YUREI from '../../assets/portfoliomain/YureiProject_800x450.webp';
import LazyImage from '../../LazyImage';
import { useTranslation } from '../../contexts/TranslationContext';

const Project = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState(() => {
    return localStorage.getItem('selectedCategory') || 'video_game';
  });
  const [showAll, setShowAll] = useState(false);
  const [visibleCards, setVisibleCards] = useState(new Set());
  const itemRefs = useRef({});

  const scrollToTop = () => {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
    const scrollingEl = document.scrollingElement || document.documentElement;
    if (scrollingEl) {
      scrollingEl.scrollTop = 0;
    }
    const rootEl = document.getElementById('root');
    if (rootEl && typeof rootEl.scrollTop === 'number') {
      rootEl.scrollTop = 0;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  useEffect(() => {
    const checkVisibility = () => {
      // Only apply on mobile
      if (window.innerWidth > 600) {
        setVisibleCards(new Set());
        return;
      }

      const viewportHeight = window.innerHeight;
      const viewportMidpoint = viewportHeight / 2;
      const newVisibleCards = new Set();

      Object.entries(itemRefs.current).forEach(([projectId, element]) => {
        if (element) {
          const rect = element.getBoundingClientRect();
          // Check if element is in upper half of screen
          if (rect.top < viewportMidpoint && rect.bottom > 0) {
            newVisibleCards.add(projectId);
          }
        }
      });

      setVisibleCards(newVisibleCards);
    };

    checkVisibility();
    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);

    return () => {
      window.removeEventListener('scroll', checkVisibility);
      window.removeEventListener('resize', checkVisibility);
    };
  }, [showAll, selectedCategory]);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setShowAll(false); // Réinitialiser pour afficher 4 projets
    localStorage.setItem('selectedCategory', category);
  };

  const portfolioItems = [
    { id: 'research-paper-reaper-voice-optimization', isEssential: true, image: MEMOIRE, category: 'research', role1: 'research', role2: 'writing' },
    { id: 'erreur-est-humaine',isEssential: true, image: ERREUR, category: 'fiction', role1: 'sound_design', role2: 'mixing' },
    { id: 'zap-from-beyond', isEssential: true, image: ZAP, category: 'video_game', role1: 'sound_design_integration', role2: 'music' },
    { id: 'advertising', isEssential: true, image: JUJUTSU, category: 'commercials', role1: 'recording', role2: 'mixing' },
    { id: 'dubbing', isEssential: true, image: MOB, category: 'dubbing', role1: 'recording', role2: 'mixing' },
    //{ id: 'the-beetles', isEssential: true, image: BEETLES, category: 'video_game', role1: 'sound_design_integration', role2: 'music', hidden: true},
    { id: 'encounters', isEssential: true, image: ENCOUNTERSMAIN, category: 'dubbing', role1: 'recording', role2: 'mixing' },
    //{ id: 'big-little-feud', isEssential: true, image: LITTLE, category: 'video_game', role1: 'sound_design_integration', role2: 'music', role3: 'game_design',hidden: true },
    //{ id: 'la-frontiere-du-monde',isEssential: false, image: FRONTIERE, category: 'sound_fiction', role1: 'recording', role2: 'sound_editing_mixing',hidden: true },
    { id: 'ventorys-inn',isEssential: true, image: VENTORY, category: 'video_game', role1: 'sound_design', role2: 'music', role3: 'game_design'},
    //{ id: 'flash-from-the-past',isEssential: false, image: FLASH, category: 'video_game', role1: 'sound_design_integration',hidden: true},
    //{ id: 'humanophobia',isEssential: false, image: HUMANOPHOBIA, category: 'video_game', role1: 'sound_design_integration', role2: 'music',hidden: true },
    //{ id: 'sugar-rush',isEssential: true, image: SUGARRUSH, category: 'video_game', role1: 'sound_design_integration', role2: 'music',hidden: true},
    { id: 'helluva-boss-vf',isEssential: false, image: HELLUVA, category: 'fiction', role1: 'mixing' },
    { id: 'urusei-yatsura',isEssential: true, image: LAMU, category: 'dubbing', role1: 'recording', role2: 'mixing' },
    //{ id: 'summertime-in-teyvat',isEssential: false, image: GENSHIN, category: 'music', role1: 'mixing' },
    //{ id: 'lucifarin-live',isEssential: true, image: LUCIFARIN, category: 'music', role1: 'recording',role2: 'composition',role3: 'mixing' },
    { id: 'coda',isEssential: false, image: CODAMAIN, category: 'musical_magazine', role1: 'recording', role2: 'mixing' },
    //{ id: 'bibliotech', isEssential: false, image: BIBLIOTECH, category: 'video_game', role1: 'sound_design_integration', role2: 'music' ,hidden: true},
    //{ id: 'the-fall', isEssential: false, image: THEFALL, category: 'video_game', role1: 'sound_design_integration', role2: 'music',hidden: true },
    { id: 'yurei', isEssential: true, image: YUREI, category: 'video_game', role1: 'sound_design_integration', role2: 'music' },
    { id: 'forlorn', isEssential: true, image: FORLORN, category: 'video_game', role1: 'sound_design_integration', role2: 'music' },
    { id: 'la-fievre', isEssential: false, image: LAFIEVREMAIN, category: 'fiction', role1: 'recording', role2: 'sound_editing_mixing' },
    { id: 'a-new-machinist', isEssential: true, image: MACHINIST, category: 'video_game', role1: 'sound_design_integration', role2: 'music' },
    { id: 'outrunner',isEssential: true, image: THEOUTRUNNER, category: 'video_game', role1: 'sound_design_integration', role2: 'music'},
  ].map(item => ({ ...item, title: t(`projectDetails.${item.id}.title`) }));

  const categoryGradients = {
    dubbing: 'rgba(50, 50, 110, 0.8)',
    commercials: 'rgba(25, 85, 25, 0.8)',
    music: 'rgba(85,85,20, 0.8)',
    video_game: 'rgba(105,35,70,0.8)',
    fiction: 'rgba(100, 50, 50, 0.8)',
    sound_fiction: 'rgba(50, 100, 50, 0.8)',
    musical_magazine: 'rgba(50, 50, 100, 0.8)',
    research: 'rgba(150, 150, 150, 0.89)'
  };

  const categoryMapping = {
    main: item => item.isEssential,
    tv_cinema: item => ['dubbing', 'fiction', 'sound_fiction', 'musical_magazine', 'commercials'].includes(item.category),
    video_game: item => ['video_game', 'research'].includes(item.category),
  };

  // Filter out hidden items first
  const visibleItems = portfolioItems.filter(item => !item.hidden);

  const filteredItems =
    selectedCategory === 'All'
      ? visibleItems
      : selectedCategory in categoryMapping
      ? visibleItems.filter(categoryMapping[selectedCategory])
      : visibleItems.filter(item => item.category === selectedCategory);

  // Limiter à 4 projets si showAll est false
  const displayedItems = showAll ? filteredItems : filteredItems.slice(0, 4);

  const categories = [
      { key: 'main', label: t('portfolio.categories.main') },
      { key: 'tv_cinema', label: t('portfolio.categories.tv_cinema') },
      { key: 'video_game', label: t('portfolio.categories.video_game') },
  ];

  return (  
    <div id="portfolio" className="section">
      <div className="container portfolioMAIN__container">
        <div className="test">
          <h3>{t('portfolio.title')}</h3>
          <div className="category-buttons">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`category-button ${selectedCategory === category.key ? 'active' : ''}`}
                onClick={() => handleCategorySelect(category.key)}
              >
                {category.label}
              </button>
            ))}
          </div>
          <ul className={`test-content ${showAll ? (selectedCategory !== 'All' ? 'category-grid' : '') : 'preview-grid'}`}>
            {displayedItems.map((item, index) => (
              <li 
                key={index} 
                ref={(el) => {
                  if (el) {
                    itemRefs.current[item.id] = el;
                  } else {
                    delete itemRefs.current[item.id];
                  }
                }}
                data-project-id={item.id}
                className={`overlay-image-portfolio ${item.category.replace(/\s/g, '-')} ${visibleCards.has(item.id) ? 'show-overlay' : 'hide-overlay'}`}
              >
                <Link to={`/project/${item.id}`} onClick={scrollToTop}>
                  <LazyImage className="image-portfolio" src={item.image} alt='' loading="lazy"/>
                  
                  <div
                    className="hover"
                    style={{
                      backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0.835171568627451) 0%, ${categoryGradients[item.category] || 'rgba(0,0,0,0.8)'} 80%, rgba(0, 0, 0, 0.5) 100%)`
                    }}
                  >
                    <div className="text">
                      <p>{item.title}</p>
                      <br />
                      <h4>{t(`portfolio.categories.${item.category}`, item.category)}</h4>
                      <br />
                      <div className="roles-container">
                        {item.role1 && <span>{t(`portfolio.roles.${item.role1}`)}</span>}
                        {item.role2 && <span>{t(`portfolio.roles.${item.role2}`)}</span>}
                        {item.role3 && <span>{t(`portfolio.roles.${item.role3}`)}</span>}
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          
          {!showAll && filteredItems.length > 4 && (
            <div className="see-more-container">
              <button 
                className="see-more-button" 
                onClick={() => setShowAll(true)}
              >
                {t('portfolio.seeMore', 'Voir plus de projets')}
              </button>
            </div>
          )}
          
          {showAll && (
            <div className="see-more-container">
              <button 
                className="see-more-button" 
                onClick={() => setShowAll(false)}
              >
                {t('portfolio.seeLess', 'Voir moins de projets')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Project;